'use strict';exports.__esModule = true;var _validate = require('../../utils/validate');

var validate = function validate(values) {
  var errors = {};

  if (!(0, _validate.emailRegexValidation)(values.email)) {
    errors.email = 'required';
  }
  if (!values.code) {
    errors.code = 'required';
  }
  if (values.code && (values.code.length > 4 || values.code.length < 4)) {
    errors.code = 'length-code';
  }
  if (!values.password) {
    errors.password = 'required';
  }
  if (!values.repeat_password) {
    errors.repeat_password = 'required';
  }
  if (values.repeat_password && values.repeat_password !== values.password) {
    errors.repeat_password = 'passwordsDoNotMatch';
  }
  if (!values.phone) {
    errors.phone = 'required';
  }
  if (!values.first_name) {
    errors.first_name = 'required';
  }
  if (values.isAgentCheckbox) {
    if (!values.logo) {
      errors.logo = 'required';
    }
    if (!values.company_name) {
      errors.company_name = 'required';
    }
    if (!values.license_number) {
      errors.license_number = 'required';
    }
    if (values.license_number) {
      var isDigits = /^\d+$/.test(values.license_number);
      if (!isDigits) {
        errors.license_number = 'digitsOnly';
      }
    }
  }
  if (!values.agree) {
    errors.agree = 'emptyField';
  }
  if (!values.code) {
    errors.code = 'emptyField';
  }
  return errors;
};exports.default =

validate;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RegistrationContainer/validate.js
// module id = 3051
// module chunks = 0